// libraries.
import { useEffect } from "react";
import { useForm } from "react-hook-form";

// interfaces.
import { IncentiveStep } from "../../rulesData";

// store.
import { useRulesSlice } from "@store/apiSlices/incentiveRules/slices/rules";

export interface EditStepFormValues {
  name: string;
  description: string;
  dayRangeFrom: number;
  dayRangeTo: number | "";
  category: IncentiveStep["category"];
  adjustment: string;
  modifiesPrice: boolean;
  details: string;
}

export const categoryOptions: {
  value: IncentiveStep["category"];
  label: string;
}[] = [
  { value: "transicion", label: "Transición" },
  { value: "bono", label: "Bono" },
  { value: "descuento", label: "Descuento" },
  { value: "remate", label: "Remate" },
];

interface UseEditStepFormProps {
  step: IncentiveStep | null;
  country: string;
  onClose: () => void;
}

export const useEditStepForm = ({
  step,
  country,
  onClose,
}: UseEditStepFormProps) => {
  const { saveIncentiveStep, isSaving } = useRulesSlice();

  const methods = useForm<EditStepFormValues>();
  const { reset, handleSubmit, watch } = methods;
  const dayRangeFrom = watch("dayRangeFrom");

  useEffect(() => {
    if (step) {
      reset({
        name: step.name,
        description: step.description,
        dayRangeFrom: step.dayRange[0],
        dayRangeTo: step.dayRange[1] ?? "",
        category: step.category,
        adjustment: step.adjustment,
        modifiesPrice: step.modifiesPrice,
        details: step.details,
      });
    }
  }, [step, reset]);

  const onSubmit = handleSubmit(async (data: EditStepFormValues) => {
    if (!step) return;
    const updated: IncentiveStep = {
      ...step,
      name: data.name,
      description: data.description,
      dayRange: [
        data.dayRangeFrom,
        data.dayRangeTo === "" ? null : Number(data.dayRangeTo),
      ],
      category: data.category,
      adjustment: data.adjustment,
      modifiesPrice: data.modifiesPrice,
      details: data.details,
    };
    await saveIncentiveStep(country, updated);
    onClose();
  });

  return { methods, dayRangeFrom, onSubmit, isSaving };
};
